import { SwalService } from './../../../shared/services/swal.service';
import { LoginService } from './../../services/login.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css', '../modalstyles.css'],
})
export class RecoverPasswordComponent implements OnInit {
  /**
   * RECOVER PASSWORD COMPONENT
   * Este modal se abre desde el Login Component mediante el botón de Recuperar contraseña
   */

  /**
   * Formulario de recuperación de contraseña
   */
  passwordRecoveryForm: FormGroup;
  /**
   * Formulario de cambio de contraseña
   */
  changePasswordForm: FormGroup;
  /**
   * Array de tipos de usuario
   */
  tipos_usuario: any;
  /**
   * Booleano de carga
   */
  _typeUserLoading: boolean;

  /**
   * Booleano que muestra un formulario dependiendo de si se envió el código al correo o no
   */
  _sent: boolean;
  _mailSent: boolean;
  _passChanged: boolean;
  /**
   * Correo que recibe el código
   */
  mail;

  constructor(
    public modalRef: BsModalRef,
    private formbuilder: FormBuilder,
    private _login: LoginService,
    private _swal: SwalService
  ) {}

  ngOnInit() {
    /**
     * Si fue enviado el formulario en falso. Se inicializa false.
     * Cambia a True apenas se envía el código al correo
     */
    this._sent = false;
    /**
     * Estado del correo enviado
     */
    this._mailSent = false;
    /**
     * Carga
     */
    this._typeUserLoading = true;
    this.tipos_usuario = [];

    this.getTiposDeUsuario();
    this.initPasswordRecoveryForm();
  }

  /**
   * Get de array tipos de usuarios
   */
  getTiposDeUsuario() {
    this._login.tipoUsuario().subscribe((data) => {
      this.tipos_usuario = data['tipo_usuario'];
      console.log(this.tipos_usuario);

      this._typeUserLoading = false;
    });
  }

  /**
   * getter para el formulario
   */
  get f() {
    return this.passwordRecoveryForm.controls;
  }

  /**
   * Formulario de recuperación de contraseña
   * Recibe tipo de usuario y correo electrónico
   */
  initPasswordRecoveryForm() {
    this.passwordRecoveryForm = this.formbuilder.group({
      tipo_usuario: [null, [Validators.required]],
      email: [
        null,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(150),
        ],
      ],
    });
  }

  /**
   * Envía el tipo de usuario y su correo para el envío del código de recuperación al correo
   */
  sendPasswordRecoveryForm() {
    this._mailSent = true;

    if (this.passwordRecoveryForm.invalid) {
      console.log('Formulario inválido');
      this._mailSent = false;
    } else {
      /**
       * Tipo de usuario que se guarda en el sessionStorage
       * Este tipo de usuario solo se usa en este componente para poder recuperar la contraseña
       * para este tipo de usuario
       */
      const userType = sessionStorage.setItem(
        'userType',
        this.f.tipo_usuario.value
      );
      /**
       * Se inicializa el formulario con el tipo de usuario
       */
      this.initChangePasswordForm(userType);

      this._login.sendTypeUserForm(this.passwordRecoveryForm.value).subscribe(
        (data) => {
          console.log(data);

          this.mail = data['correo'];

          this._sent = true;
          this._mailSent = false;
        },
        (error) => {
          if (error.error['noExiste']) {
            this._swal.showErrorModal(
              'El usuario no existe',
              'No existe un usuario con ese correo o NIT, por favor verifica los datos suministrados.'
            );
          }

          console.log(error);
          this._mailSent = false;
        }
      );
    }
  }

  /**
   * GETTER para el formulario
   */
  get c() {
    return this.changePasswordForm.controls;
  }

  /**
   * Formulario de cambio de contraseña
   * El usuario coloca la nueva contraseña que quiere
   */
  initChangePasswordForm(userType) {
    this.changePasswordForm = this.formbuilder.group(
      {
        tipo_usuario: [userType, [Validators.required]],
        codigo: [
          null,
          [
            Validators.required,
            Validators.maxLength(4),
            Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          ],
        ],
        password: [
          null,
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(190),
          ],
        ],
        password_confirmation: [null, Validators.required],
      },
      {
        validator: MustMatch('password', 'password_confirmation'),
      }
    );
  }

  /**
   * Evento submit del formulario
   * Realiza el cambio de la contraseña
   */
  doPasswordChange() {
    this._passChanged = true;

    if (this.changePasswordForm.invalid) {
      console.log('Formulario inválido');
      return;
    } else {
      this._login.sendChangePassword(this.changePasswordForm.value).subscribe(
        (data) => {
          console.log(data);

          sessionStorage.clear();
          localStorage.clear();

          this.modalRef.hide();

          this._swal.showSuccessModal(
            'Contraseña modificada exitosamente',
            'Por favor, inicie sesión con la nueva contraseña.'
          );

          this._passChanged = false;
        },
        (error) => {
          console.log(error);
          this._passChanged = false;
        }
      );
    }
  }
}

// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
